import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import BusyIntegrationActions from '../../../../../../../actions/integrations/busyIntegrationAction';
/**
 *
 */
const SyncData = ({
  syncVendorLoading, syncProductLoading, user, setStep, syncVendor, syncProduct,
}) => {
  useEffect(() => {
  }, []);

  const [pullProductsData, setPullProductsData] = useState(false);
  const [pullVendorsData, setPullVendorsData] = useState(false);

  const location = useLocation();
  const { state } = location;
  const { id } = state || {};

  const handleSubmit = () => {
    const payload2 = {
      integration_busy_id: id,
    };
    if (pullVendorsData) {
      syncVendor(payload2, () => {
        if (pullProductsData) {
          syncVendor(payload2, () => {
            setStep(7);
          });
        } else {
          setStep(7);
        }
      });
    } else if (pullProductsData) {
      syncProduct(payload2, () => {
        if (pullVendorsData) {
          syncProduct(payload2, () => {
            setStep(7);
          });
        } else {
          setStep(7);
        }
      });
    } else {
      setStep(7);
    }
  };

  return (
    <Fragment>
      <div className="busy__sync-data-wrapper">
        Pull vendors and products created in Busy
        <div className="ant-row" style={{ display: 'flex', marginTop: '20px' }}>
          <H3Button
            text="Sync Products"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => setPullProductsData(true)}
            customClass="busy__sync-submit"
            disabled
          />
        </div>
        <div className="ant-row" style={{ display: 'flex', marginTop: '20px' }}>
          <H3Button
            text="Sync Vendors"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => setPullVendorsData(true)}
            customClass="busy__sync-submit"
            disabled
          />
        </div>
        <div className="ant-row" style={{ display: 'flex', marginTop: '20px' }}>
          <H3Button
            text="Back"
            buttonType={defaultButtonTypes.BLUE_BORDERED}
            onClick={() => setStep(5)}
            customClass="busy__action-button"
            disabled={syncVendorLoading || syncProductLoading}
          />
          &nbsp;&nbsp;
          &nbsp;&nbsp;
          <div>
            <H3Button
              text="Save and Continue"
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              onClick={() => handleSubmit()}
              customClass="busy__sync-submit"
              isLoading={syncVendorLoading || syncProductLoading}
              disabled={syncVendorLoading || syncProductLoading}
            />
          </div>
        </div>
      </div>

    </Fragment>
  );
};

const mapStateToProps = ({ /* Import Reducers here */ UserReducers, BusyIntegrationReducers }) => ({
  user: UserReducers.user,
  syncProductLoading: BusyIntegrationReducers.syncProductLoading,
  syncVendorLoading: BusyIntegrationReducers.syncVendorLoading,

});

const mapDispatchToProps = (/* Import actions here */ dispatch) => ({
  syncVendor: (payload, callback) => dispatch(BusyIntegrationActions.syncVendor(payload, callback)),
  syncProduct: (payload, callback) => dispatch(BusyIntegrationActions.syncProduct(payload, callback)),
});

SyncData.propTypes = {
  user: PropTypes.any,
  syncVendorLoading: PropTypes.bool,
  syncProductLoading: PropTypes.bool,
  setStep: PropTypes.func,
  syncVendor: PropTypes.func,
  syncProduct: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SyncData));
